const purchasetype = {
    getlist: 'purchasetype/getlist',
    add: 'purchasetype/add',
    update: 'purchasetype/update',
    remove: 'purchasetype/remove',
    get: 'purchasetype/get',
    getall: 'purchasetype/getall',
    clearcache: 'purchasetype/clear-cache',
}
export default purchasetype